import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Route } from '@angular/router';
import { Device } from '@awesome-cordova-plugins/device/ngx';

export const coreDataRoutes: Route[] = [];

@NgModule({
  imports: [CommonModule, RouterModule],
  providers: [Device],
})
export class CoreDataModule {}
